export default __webpack_public_path__ + "static/media/band14.211bfb87.jfif";